import React from 'react'
import { DefaultTheme } from 'styled-components'
import { Wrapper } from './styles'

interface AttractionsDropdownProps {
    creator?: JSX.Element
    handleButtonClick?: () => void
    theme?: DefaultTheme
    promotionBox?: JSX.Element
}

const AttractionDropdown = ({
    creator,
    handleButtonClick,
    theme,
    promotionBox,
}: AttractionsDropdownProps) => {
    const hasDarkMode = theme?.mode === 'dark'

    return (
        <Wrapper
            pt={[hasDarkMode ? 8 : 24, 40]}
            pb={[24, 40]}
            pl={[16, 40]}
            pr={[16, 40]}
            isFullWidth
        >
            {promotionBox}
            {creator && React.cloneElement(creator, { handleButtonClick })}
        </Wrapper>
    )
}

export default AttractionDropdown
